<template>
  <svg :width="radius * 2" :height="radius * 2">
    <circle
      v-if="background"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke-width="strokeWidth"
      :stroke-dasharray="circumference"
      stroke-dashoffset="0"
    ></circle>

    <circle
      ref="circle"
      id="bar"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke-width="strokeWidth"
      :stroke-dasharray="circumference"
      stroke-dashoffset="0"
      :style="`transition-duration: ${animationDurationMillis}ms; transition-timing-function: ${animationTimingFunction}`"
    ></circle>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  vertical-align: middle;
}

svg circle {
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 1000ms ease;
  stroke: $color-darkened-150;
}

svg #bar {
  stroke: currentColor;
}
</style>

<script>
export default {
  name: 'ProgressCircle',
  props: {
    percent: {
      type: Number,
      required: true,
    },
    circleWidth: {
      type: Number,
      default: 70,
    },
    strokeWidth: {
      type: Number,
      default: 8,
    },
    background: {
      type: Boolean,
      default: true,
    },
    animationDurationMillis: {
      type: Number,
      default: 1000,
    },
    /**
     * https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function
     */
    animationTimingFunction: {
      type: String,
      default: 'linear',
    },
  },
  watch: {
    percent() {
      this.calculate();
    },
  },
  computed: {
    radius() {
      return this.circleWidth / 2;
    },
    normalizedRadius() {
      return this.radius - this.strokeWidth;
    },
    circumference() {
      return Math.PI * (this.normalizedRadius * 2);
    },
  },
  methods: {
    calculate() {
      let val = this.percent;
      if (val < 0) val = 0;
      if (val > 100) val = 100;
      this.$refs.circle.style.strokeDashoffset = ((100 - val) / 100) * this.circumference;
    },
  },
  mounted() {
    this.calculate();
  },
};
</script>
